import { defineStore } from "pinia";

export const editorStateStore = defineStore("modelId", {
  state: () => ({
    modelId: null as null | string,
    openLayerIdHistory: [] as string[],
    validationTriggerCounter: 0 as number,
  }),
  actions: {
    setModelId(newId: string) {
      this.modelId = newId;
    },
    openLayer(id: string) {
      this.openLayerIdHistory.push(id);
    },
    closeLayer(id: string) {
      this.openLayerIdHistory = this.openLayerIdHistory.filter((el) => el !== id);
    },
    validationTriggered() {
      this.validationTriggerCounter++;
    },
    validationCompleted() {
      this.validationTriggerCounter--;
    },
  },
  getters: {
    getModelId(): null | string {
      return this.modelId;
    },
    getTopLayer(): string {
      return this.openLayerIdHistory[this.openLayerIdHistory.length - 1];
    },
    getValidationTriggerCounter(): number {
      return this.validationTriggerCounter;
    },
  },
});
